import { render, staticRenderFns } from "./TermLabels.vue?vue&type=template&id=5b60cbc6&"
import script from "./TermLabels.vue?vue&type=script&lang=js&"
export * from "./TermLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports